var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenTic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ix:success-filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.9986 13.332C43.1798 13.332 13.332 43.1798 13.332 79.9986C13.332 116.817 43.1798 146.665 79.9986 146.665C116.817 146.665 146.665 116.817 146.665 79.9986C146.665 43.1798 116.818 13.332 79.9986 13.332ZM105.104 56.1802L114.531 65.6073L93.9314 86.293L73.332 106.979L48.6186 82.2652L58.0455 72.838L73.332 88.1245L105.104 56.1802Z",
    fill: "#0E9715"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 23",
    d: "M53 77.84L73.2105 98L117 53",
    stroke: "#BEBEBE",
    strokeWidth: 14
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTic);
export default __webpack_public_path__ + "static/media/greenTic.9080e98b5353ff0b5a33cb213731ba97.svg";
export { ForwardRef as ReactComponent };